export default __webpack_public_path__ + "static/media/ms-unsaved.42174223.svg";